// import Swiper core and required modules
import React, { useEffect, useState } from 'react';
import { EffectCoverflow, Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import styles from './EventSwiper.module.scss';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-coverflow';

const Swipe = () => {
  const startinfNumOfPhotos = window.innerWidth >= 1300 ? 3 : window.innerWidth >= 1000 ? 2 : 1;
  const [numOfPhotos, setNumOfPhotos] = useState(startinfNumOfPhotos);

  useEffect(() => {
    const handleResize = (event) => {
      const width = event.currentTarget.innerWidth;
      if (width <= 1000) {
        setNumOfPhotos(1);
      } else if (width <= 1300) {
        setNumOfPhotos(2);
      } else {
        setNumOfPhotos(3);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <Swiper
      // install Swiper modules
      loop={true}
      speed={600}
      autoplay={{
        delay: 600,
        disableOnInteraction: false,
      }}
      slidesPerView={numOfPhotos}
      modules={[Autoplay, EffectCoverflow]}
      className={styles['swiper-container']}
    >
      <SwiperSlide className={styles['swiper-slide']}>
        <img src="/images/books-1.jpg" alt="" />
        <h4>Book Event</h4>
      </SwiperSlide>
      <SwiperSlide className={styles['swiper-slide']}>
        <img src="/images/app-2.jpg" alt="" />
        <h4>Banking Event</h4>
      </SwiperSlide>
      <SwiperSlide className={styles['swiper-slide']}>
        <img src="/images/Health-Check-ups.png" alt="" />
        <h4>Check-up Event</h4>
      </SwiperSlide>
      <SwiperSlide className={styles['swiper-slide']}>
        <img src="/images/product-2.jpg" alt="" />
        <h4>Sales Event</h4>
      </SwiperSlide>
      <SwiperSlide className={styles['swiper-slide']}>
        <img src="/images/branding-2.jpg" alt="" />
        <h4>Beauty Event</h4>
      </SwiperSlide>
      <SwiperSlide className={styles['swiper-slide']}>
        <img src="/images/fair.jpg" alt="" />
        <h4>Job Fair Event</h4>
      </SwiperSlide>
    </Swiper>
  );
};

export default Swipe;
